import { ApplicationState } from '../../types';

export const selectAppMeta = ({ appMeta }: ApplicationState) => appMeta;

export const selectWorkspace = ({ appMeta }: ApplicationState) => appMeta.workspace;
export const selectAppMetaPath = ({ appMeta }: ApplicationState) => appMeta.path;
export const selectAppMetaProduct = ({ appMeta }: ApplicationState) => appMeta.product;
